import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface ModeState {
  /** Refinance hub, intake, and scenarios—additive; does not disable purchase workflows. */
  refinanceEnabled: boolean;
  isInvestorMode: boolean;
}

const initialState: ModeState = {
  refinanceEnabled: false,
  isInvestorMode: false,
};

const modeSlice = createSlice({
  name: 'mode',
  initialState,
  reducers: {
    setRefinanceEnabled: (state, action: PayloadAction<boolean>) => {
      state.refinanceEnabled = action.payload;
    },
    setInvestorMode: (state, action: PayloadAction<boolean>) => {
      state.isInvestorMode = action.payload;
    },
    toggleInvestorMode: (state) => {
      state.isInvestorMode = !state.isInvestorMode;
    },
  },
});

export const { setRefinanceEnabled, setInvestorMode, toggleInvestorMode } =
  modeSlice.actions;
export default modeSlice.reducer;
